<template>
  <div class="container-fluid">
    <div class="summaries">
      <div class="summary green-icon">
        <div class="icon-box">
          <span class="material-icons material-icons-outlined">devices</span>
        </div>
        <div class="text-box">
          <p class="data-title">
            {{ deviceCount > 1 ? "Devices" : "Device" }}
          </p>
          <p class="data-num">
            {{ deviceCount }}
          </p>
        </div>
      </div>
      <div class="summary yellow-icon">
        <router-link :to="`/users/edit/${this.getUserSession.id}`">
          <div class="icon-box">
            <span class="material-icons">layers</span>
          </div>
        </router-link>
        
        <div class="text-box">
          <p class="data-title">Invoices</p>
          <p class="data-num">{{ invoiceCount }}</p>
        </div>
      </div>
      <div class="summary blue-icon">
        <div class="icon-box">
          <span class="material-icons material-icons-outlined"
            >error_outline</span
          >
        </div>
        <div class="text-box">
          <p class="data-title">Warning</p>
          <p class="data-num">{{ warningCount }}</p>
        </div>
      </div>
      <div class="summary red-box">
        <div class="icon-box">
          <span class="material-icons material-icons-outlined"
            >error_outline</span
          >
        </div>
        <div class="text-box">
          <p class="data-title">Critical Devices</p>
          <p class="data-num">{{ criticalWarningCount }}</p>
        </div>
      </div>
    </div>
    <div class="chart-map">
      <div class="geo-chart">
        <div class="select-device">
          <el-select
            style="width: 100%"
            v-model="activeDevice"
            id="active-device"
            placeholder="Choose Device"
            @change="changeActiveDevice(activeDevice)"
          >
            <el-option
              v-for="(device, key) in devices"
              :key="key"
              :label="`Device ${device}`"
              :value="device"
            ></el-option>
          </el-select>
        </div>
        <div class="device-expiry">
          <div class="device-details">
            <div class="icon-box">
              <span class="material-icons">event</span>
            </div>
            <div class="expiry-details">
              <p>Expiry Date</p>
              <p class="expiry">{{ deviceExpiry ? deviceExpiry : "---" }}</p>
            </div>
          </div>
          <div class="device-image">
            <img src="../../../assets/img/Arnergy-5000.jpeg" alt="Blue box" />
          </div>
        </div>
        <div class="chart-control">
          <div class="shuffle-type" v-if="chartData">
            <p
              v-on:click="changeActiveDevice(activeDevice, 'temperature')"
              :class="getClass('temperature')"
            >
              Temperature
            </p>
            <p
              @click="changeActiveDevice(activeDevice, 'humidity')"
              :class="getClass('humidity')"
            >
              Humidity
            </p>
          </div>
          <line-chart
            v-if="chartData"
            :chartdata="chartData"
            :options="options"
          ></line-chart>
          <div>
            <div>
              <p v-if="loadingChartData" class="process">
                <a-spin size="large" tip="Loading..." />
              </p>
            </div>
            <p v-if="emptyChart && !loadingChartData" class="loading-chart">
              Data unavailable for this device. Please try again or choose
              another device
            </p>
          </div>
        </div>
      </div>

      <GmapMap
        class="map-box"
        :zoom="zoom"
        :center="center"
        map-type-id="terrain"
        ref="map"
      >
        <GmapMarker
          v-for="(marker, index) in markers"
          :key="index"
          :position="marker.latLng"
          :title="marker.name"
          :clickable="true"
          @click="log"
        />
      </GmapMap>
    </div>
  </div>
</template>

<script>
/* eslint-disable ok */

import customBox from "../../../components/pages/dashboard/components/customBox.vue";
import customGridBox from "../../../components/pages/dashboard/components/customGridBox.vue";
import customGeoBox from "../../../components/pages/dashboard/components/customGeoBox.vue";
import customChart from "../../../components/pages/dashboard/components/customChart.vue";
import customDatePicker from "../../../components/pages/dashboard/components/customDatePicker.vue";
import customPieChart from "../../../components/pages/dashboard/components/customPieChart.vue";
import _ from "lodash";
import Vue from "vue";
import axios from "axios";

import { HTTP as IOTHTTP } from "../../../store/actions";
import moment from "moment";
const icon =
  "data:image/png;base64,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";

import { mapGetters, mapActions } from "vuex";
import LineChart from "./LineChart.vue";

export default {
  components: {
    "line-chart": LineChart
  },
  data() {
    return {
      deviceExpiry: null,
      daysToExpire: 100,
      inverterId: null,
      markers: [],
      place: null,
      map: null,
      center: { lat: 9.082, lng: 8.6753 },
      url: icon,
      devices: null,
      activeDevice: null,
      chartType: "temperature",
      loadingChartData: true,
      emptyChart: false,
      alarmTableFields: [
        {
          field: "datetime",
          label: "Date/Time",
          sortable: "true"
        },
        {
          field: "device_id",
          label: "Device ID",
          sortable: "true"
        },
        {
          field: "alarmType",
          label: "Alarm Type",
          sortable: "true"
        },
        {
          field: "alarmValue",
          label: "Alarm Value",
          sortable: "true"
        },
        {
          field: "threshValue",
          label: "Threshold Value",
          sortable: "true"
        },
        {
          field: "thresh",
          label: "Threshold",
          sortable: "true"
        },
        {
          field: "comment",
          label: "Comment",
          sortable: "true"
        }
      ],
      chartData: null,
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: false
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: false
          // position: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false
      },
      deviceCount: 0,
      invoiceCount: 0,
      criticalWarningCount: 0,
      warningCount: 0,
      zoom: 6,
      devices: []
    };
  },
  computed: {
    ...mapGetters(["getUserSession", "getAssignedDevices"])
  },
  components: {
    // GreyPagination
    "custom-box": customBox,
    "custom-grid-box": customGridBox,
    "custom-geo-box": customGeoBox,
    "custom-chart": customChart,
    "custom-pie-chart": customPieChart,
    "custom-date-picker": customDatePicker
  },
  methods: {
    getClass(chartType) {
      return { active: this.chartType === chartType };
    },
    getSMFilter(assignedDevices) {
      let filter = {
        where: {
          or: []
        }
      };
      assignedDevices.map(v => {
        filter.where.or.push({ CID: v });
      });
      return filter;
    },
    log(msg) {
      console.log(msg);
    },
    invoice() {
      let filter = "";
      let userId = this.getUserSession.id;
      const httpUtils = this.$httpUtils;
      if (this.$can("am", "customer")) {
        filter = {
          order: "id DESC",
          where: {
            and: [
              { userId: userId },
              {
                or: [
                  { type: "subscription" },
                  { type: "autoMonthlySubscription" }
                ]
              }
            ]
          },
          limit: 150,
          include: ["user"]
        };
      }
      let url = `/invoices?filter=${JSON.stringify(filter)}`;

      httpUtils.instance
        .get(url)
        .then(response => {
          this.invoiceCount = response.data.length;
        })
        .catch(error => {
          this.errors = "Error occured at our end!";
        });
    },
    async deviceLocation() {
      try {
        const HTTP = this.$httpUtils.instance;
        let userId = this.getUserSession.id;
        console.log(userId)
        let LOCATIONURL = ``;
        if (this.$can("am", "sm")) {
          let assignedDevices = JSON.parse(this.getUserSession.assignedDevices);
          this.deviceCount = assignedDevices.length;
          if (this.deviceCount > 0) {
            let filter = this.getSMFilter(assignedDevices);
            LOCATIONURL = `/installations?filter=${JSON.stringify(filter)}`;
          }
        } else {
          const filter = {
            where: {
              and: [
                { userId: `${userId}` },
                {
                  or: [
                    { status: "requested" },
                    { status: "commissioned" },
                    { status: "completed" }
                  ]
                }
              ]
            },
            include: ["locations"]
          };
          LOCATIONURL = `/installations?filter=${JSON.stringify(filter)}`;
        }

        let resp = await HTTP.get(LOCATIONURL)
          .then(res => res)
          .catch(httpError => {
            console.log({ httpError });
          });
        let data = resp.data;
        if (data.length > 0) {
          this.deviceCount = data.length;
          data.map(m => {
            let { locations, name, CID } = m;
            if (locations) {
              let { position, streetRoute } = locations;
              let latLng = position;
              this.markers.push({
                latLng,
                name: `${streetRoute} - ${CID}`,
                CID
              });
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async init(lowerLimit = null, upperLimit = null, inverterId = null) {
      try {
        const httpUtils = this.$httpUtils;

        this.isLoading = true;
        let assignedDevices = [];
        if (this.$can("am", "sm")) {
          assignedDevices = this.getUserSession.assignedDevices;
        } else {
          assignedDevices = this.getAssignedDevices; // ==> ['416931', '416850'];
        }
        // console.log({ assignedDevices, sm: this.$can("am", "sm") });

        let smQuery = `{
          surveillanceByDateAndIDs(DateRange:["${lowerLimit ||
            moment()
              .subtract(7, "days")
              .toISOString()}","${upperLimit ||
          moment().toISOString()}"],IDs:${assignedDevices || []}){
                name
                deviceId
                fault
                severity
                status
                id
                startTime
                endTime
              }
            }`;

        const GraphHTTP = this.$httpUtils.GraphHTTP;
        const res = GraphHTTP.post("/graphql", { query: smQuery });
        let { surveillanceByDateAndIDs } = res.data.data;

        let yo = surveillanceByDateAndIDs || [];
        let goodWarning = yo.filter(
          v => v.severity == "Critical" && v.status != "RESOLVED"
        );
        this.criticalWarningCount = goodWarning.length;
        this.isLoading = false;
        let openWarning = yo.filter(v => v.status == "OPEN");
        this.warningCount = openWarning.length;
        return goodWarning;
      } catch (error) {
        console.log("init ==>", error);
        this.isLoading = false;
        return [];
      }
    },
    async getWeatherData(id) {
      let query = this.geoDataQuery(id);
      const GraphHTTP = this.$httpUtils.GraphHTTP;
      const res = await GraphHTTP.post("/graphql", {
        query: query
      });
      this.stripForChart(res.data.data.geoData);
    },
    geoDataQuery(id) {
      return `
        {geoData(ID:"${id}"){
          id
          createdAt
          deviceId
          weather{
            icon
            description
            main
            id
          }
          coord{
            lon
            lat
          }
          main{
            temp
            temp_min
            weather
            humidity
            temp_max
            pressure
            sea_level
            feels_like
          }
        }}`;
    },
    stripForChart(geoData) {
      let deviceLabels = [];
      let deviceTempData = [];
      let deviceHumidData = [];
      geoData.map(device => {
        deviceLabels[deviceLabels.length] = new Date(device.createdAt)
          .toLocaleTimeString([], {
            hour12: true,
            hour: "2-digit",
            minute: "2-digit"
          })
          .toUpperCase();
        deviceTempData[deviceTempData.length] = device.main.temp;
        deviceHumidData[deviceHumidData.length] = device.main.humidity;
      });
      const lineColor = this.genRandomHexCode();
      this.loadingChartData = false;
      if (deviceLabels.length > 0) {
        this.emptyChart = false;
        const allTempData = {
          label: "Device " + geoData[0].deviceId,
          data:
            this.chartType === "temperature" ? deviceTempData : deviceHumidData,
          fill: false,
          borderColor: lineColor,
          backgroundColor: lineColor,
          borderWidth: 1,
          tension: 0 // increase to make the line curvy
        };
        this.fillChart(deviceLabels, allTempData);
      } else this.emptyChart = true;
    },
    genRandomHexCode() {
      return "#" + Math.floor(Math.random() * 16777215).toString(16);
    },
    fillChart(labels, data) {
      this.chartData = { labels, datasets: [data] };
    },
    changeActiveDevice(id, type) {
      this.loadingChartData = true;
      if (this.chartData) this.chartData = null;
      if (this.chartType === type) this.deviceExpiry = null;
      if (this.activeDevice !== id) this.chartType = "temperature";
      if (!this.activeDevice) this.activeDevice = id;
      this.chartType = type;
      this.getWeatherData(id);
      this.getPendingChanges(id);
    },
    async getPendingChanges(deviceId) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric"
      };

      const HTTP = this.$httpUtils.NotificationHTTP;
      // const endpoint = "https://iot-solarbase.arnergy.com/devicestate/";
      const res = await HTTP.get(`configuration/${deviceId}`);

      this.deviceExpiry = new Date(
        res.data.response.expiryDate
      ).toLocaleDateString(undefined, options);
      this.daysToExpire = res.data.response.daysToExpire;
      this.$store.commit("setActiveDeviceDaysToExpire", this.daysToExpire);
      // window.location.reload()
    }
  },
  async mounted() {
    this.inverterId = this.$route.params.deviceId;
    this.init();
    this.deviceLocation();
    this.invoice();
    if (this.$can("am", "sm")) {
      this.devices = JSON.parse(this.getUserSession.assignedDevices);
    } else {
      this.devices = this.getAssignedDevices;
    }

    this.changeActiveDevice(this.devices[0], "temperature");
  }
};
</script>

<style lang="scss" scoped>
.process {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.small {
  max-width: 600px;
  margin: 150px auto;
}

.chart-map {
  display: flex;
  align-items: flex-start;
  min-height: 600px;
  margin-bottom: 4rem;
}

.geo-chart {
  width: 45%;
  margin-right: 1rem;
  box-sizing: border-box;
  height: 100%;
  min-height: 600px;
}

.chart-control {
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 0px 3px rgba(65, 65, 65, 0.16);
  padding: 4rem 2rem;
}

.shuffle-type {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3rem;
}

.shuffle-type p {
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  cursor: pointer;
}

.shuffle-type p:hover {
  background: rgba(26, 147, 202, 0.1);
}

.shuffle-type p:first-child {
  margin-right: 2rem;
}

.shuffle-type p.active {
  background: rgba(26, 147, 202, 0.1);
  color: rgb(26, 147, 202);
}

.loading-chart {
  text-align: center;
  // margin-top: 5rem;
  color: rgb(26, 147, 202);
}

p {
  margin: 0;
  color: rgb(95, 95, 95);
  font-size: 1.1rem;
}

.summaries {
  margin: 3rem 0rem;
  display: flex;
  justify-content: space-between;
}

.summary {
  width: 22.5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  // border: 0.5px solid rgba(65, 65, 65, 0.16);
  box-shadow: 0px 0px 3px rgba(65, 65, 65, 0.16);
  border-radius: 0.4rem;
  padding: 2.5rem;
}

.icon-box {
  background: rgba(223, 223, 223, 0.5);
  border-radius: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  color: rgb(95, 95, 95);
}

.green-icon .icon-box {
  background: rgba(0, 128, 0, 0.08);
  color: green;
}

.blue-icon .icon-box {
  background: rgba(0, 139, 139, 0.08);
  color: darkcyan;
}

.red-box {
  background: tomato;
  color: #ffffff;
}

.red-box .icon-box {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.red-box p {
  color: #ffffff;
}

.text-box {
  text-align: center;
}

.text-box .data-num {
  font-size: 2.5rem;
  font-weight: 400;
}

.top-subtitle {
  color: #999;
}

.title {
  margin-bottom: 50px;
}

.footer-area {
  background-color: #ffffff;
  padding-bottom: 100px;
}

.header-area {
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  padding: 50px 0;
}

.content {
  margin: 0 auto;
  width: 100%;
  max-width: 960px;
  padding: 50px 0;
}

.no-top-padding {
  padding-top: 0;
}

.grid {
  display: grid;
  grid-gap: 20px;
}

.grid-1 {
  grid-template-columns: 0.5fr 0.5fr 1fr;
}

.grid-2 {
  margin-top: 20px;
  grid-template-columns: 0.5fr 1fr 0.5fr;
}

.box {
  background-color: white;
  border: 1px solid #f0f0f0;
  padding: 20px;
  height: 220px;
}

.small {
  display: block;
  margin-top: -10px;
  color: #999;
}

.chart-info {
  display: flex;
  margin-top: 30px;
}

.chart-section {
  margin-bottom: 30px;
}

.select-device {
  margin-bottom: 1rem;
}

.device-expiry {
  margin-bottom: 1rem;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 0px 3px rgba(65, 65, 65, 0.16);
  display: flex;
  justify-content: space-between;
}

.device-details {
  display: flex;
  padding: 2rem;
  align-items: center;
}

.device-expiry .icon-box {
  background: rgba(26, 147, 202, 0.16);
  border-radius: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  color: rgb(26, 147, 202);
  margin-right: 2rem;
}

.device-expiry .expiry-details p.expiry {
  font-size: 1.6rem;
}

.device-expiry .device-image {
  height: 94px;
  overflow: hidden;
  margin-right: 2rem;
}

.device-expiry .device-image img {
  height: 200px;
}

.info-item {
  display: flex;
  align-items: center;

  i {
    margin-right: 5px;
  }

  & + .info-item {
    margin-left: 30px;
  }
}

.green-icon .icon-box {
  background: rgba(0, 128, 0, 0.08);
  color: #008000;
}

.blue-icon .icon-box {
  background: rgba(0, 139, 139, 0.08);
  color: #008b8b;
}

.red-box {
  background: #ff6347;
  color: #ffffff;
}

.red-box .icon-box {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.red-box p {
  color: #ffffff;
}

.text-box {
  text-align: center;
}

.text-box .data-num {
  font-size: 2.5rem;
  font-weight: 400;
}

.map-box {
  flex: 1;
  min-height: 600px;
  height: 100%;
}

.top-subtitle {
  color: #999;
}

.title {
  margin-bottom: 50px;
}

.footer-area {
  background-color: #ffffff;
  padding-bottom: 100px;
}

.header-area {
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  padding: 50px 0;
}

.content {
  margin: 0 auto;
  width: 100%;
  max-width: 960px;
  padding: 50px 0;
}

.no-top-padding {
  padding-top: 0;
}

.grid {
  display: grid;
  grid-gap: 20px;
}

.grid-1 {
  grid-template-columns: 0.5fr 0.5fr 1fr;
}

.grid-2 {
  margin-top: 20px;
  grid-template-columns: 0.5fr 1fr 0.5fr;
}

.box {
  background-color: white;
  border: 1px solid #f0f0f0;
  padding: 20px;
  height: 220px;
}

.small {
  display: block;
  margin-top: -10px;
  color: #999;
}

.chart-info {
  display: flex;
  margin-top: 30px;
}

.chart-section {
  margin-bottom: 30px;
}

.info-item {
  display: flex;
  align-items: center;
  i {
    margin-right: 5px;
  }

  & + .info-item {
    margin-left: 30px;
  }

  span {
    font-size: 12px;
  }
}

#map {
  height: 600px;
  background: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/customerDashboard/index.vue